/**
 * Sets query paramters on URL. Handles already existing query parameters.
 * @param {String} url base URL String
 * @param {Object} params query parameters
 * @returns url with query paramters
 */
export function setQueryParams(url, params = {}) {
  let urlObject
  try {
    urlObject = new URL(url)
  } catch (error) {
    throw new TypeError(`Invalid URL provided: ${url}`)
  }

  Object.entries(params).forEach(([key, value]) => {
    urlObject.searchParams.set(key, value)
  })
  return urlObject.toString()
}
